import loadable from '@loadable/component';

// 懒加载组件
const HospitalManagement = loadable(() => import('./hospitalManagement/HospitalManagement'));
const SupplierManagement = loadable(() => import('./supplierManagement/SupplierManagement'));
const SupplierUserManagement = loadable(() => import('./supplierUserManagement/SupplierUserManagement'));
const UserManagement = loadable(() => import('./userManagement/UserManagement'));
const SupplyCommodityManagement = loadable(() => import('./supplyCommodityManagement/SupplyCommodityManagement'));
const ReportTemplateManagement = loadable(() => import('./ReportTemplateManagement/reportTemplateManagement'));
const AsyncReportManagement = loadable(() => import('./asyncReportManagement/AsyncReportManagement'));
const ExportManagement = loadable(() => import('./exportManagement/ExportManagement'));
const SupDatasetHospitalManagement = loadable(() => import('./supplyDatasetCommodityManagement/SupplyDatasetCommodityManagement'));
const SupRoleManagement = loadable(() => import('./supRoleManagement/SupRoleManagement'));
const SupplierWithUpstreamManagement = loadable(() => import('./supplierWithUpstreamManagement/SupplierWithUpstreamManagement'));

export const subRoutes = [
  {
    path: '/ReportTemplateManagement',
    component: ReportTemplateManagement
  },
  {
    path: '/HospitalManagement',
    component: HospitalManagement
  },
  {
    path: '/SupplierManagement',
    component: SupplierManagement
  },
  {
    path: '/SupplierUserManagement',
    component: SupplierUserManagement
  },
  {
    path: '/SupplyCommodityManagement',
    component: SupplyCommodityManagement
  },
  {
    path: '/UserManagement',
    component: UserManagement
  },
  {
    path: '/AsyncReportManagement',
    component: AsyncReportManagement
  },
  {
    path: '/ExportManagement',
    component: ExportManagement
  },
  {
    path: '/SupDatasetHospitalManagement',
    component: SupDatasetHospitalManagement
  },
  {
    path: '/SupRoleManagement',
    component: SupRoleManagement
  },
  {
    path: '/SupplierWithUpstreamManagement',
    component: SupplierWithUpstreamManagement
  }
];
